module Meevo.Components.Controls.SmartMover {
    import Manufacturer = Model.Manufacturer;

    export class CoreManufacturersToProductCatsStrategy implements ICollectionPopulate {
        constructor(private parent: ICollectionBase<Model.ProductCategory>, private child: ICollectionBase<Manufacturer>) {
        }

        populate(): void {
            const groups = _.groupBy(this.child.models, manufacturer => manufacturer.get('categoryId'));
            for (const productCat of this.parent.models) {
                const categoryId = productCat.get('id');
                const manufacturers = groups[categoryId] || [];
                (<ISmartMoverCategoryModel<Model.ProductCategory>>productCat).resetModels(manufacturers);
            }
        }
    }
}